import * as actions from '../actions/currentTempSettingActionTypes';


const initialState = {
  appBasePath: ""
}


function currentTempSetting(state = initialState, action) {  
  switch (action.type) {
    case actions.CURRENT_TEMPSETTING_SET_APPBASEPATH:
      return {
        ...state, 
        appBasePath: action.appBasePath
      }

    default:        
      return state
  } 
}
  
export default currentTempSetting